import { Path, SVG } from '@wordpress/primitives';

export default (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={ { fill: "none" } } stroke="currentColor" strokeWidth="1.5">
		<Path d="M12 3V16M6 10.5L12 16L17.5 10.5M4.75 15V19.25H19.25V15" vectorEffect="non-scaling-stroke" />
	</SVG>
);
